import { ReactComponent as FlagIcon } from "./svg/hn-flag.svg";
import "../flag-icon.scss";

export const HNFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
